import { BackButton } from '../../navigation';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import PlaylistAssignmentsAssignedByFilter from './PlaylistAssignmentsAssignedByFilter';
import PlaylistAssignmentsMobileFilter from './PlaylistAssignmentsMobileFilter';
import { RouterSearchInput } from '../../filters';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import { View } from 'foundations-components/transitional/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PlaylistAssignmentsTablePage = ({
  children,
  headerTitle,
  backButton,
  tableCount,
  searchFilter,
  actions
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: isMobile ? '0' : '200',
      minBlockSize: "26px",
      paddingInline: isMobile ? '400' : '0',
      children: backButton && /*#__PURE__*/_jsx(BackButton, {
        exact: true,
        to: backButton.to,
        children: backButton.title
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: isMobile ? 'column' : 'row',
      paddingInline: isMobile ? '400' : '0',
      children: [/*#__PURE__*/_jsxs(Flex, {
        inlineSize: "100%",
        children: [/*#__PURE__*/_jsxs(Box, {
          grow: 1,
          children: [/*#__PURE__*/_jsx(Text, {
            as: isMobile ? 'h5' : 'h4',
            paddingBlockEnd: "100",
            children: headerTitle
          }), /*#__PURE__*/_jsxs(List, {
            marginBlockEnd: "200",
            use: "inline-divided",
            children: [/*#__PURE__*/_jsx(ListItem, {
              children: tableCount
            }), !isMobile && /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(PlaylistAssignmentsAssignedByFilter, {})
            })]
          })]
        }), isMobile && /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(PlaylistAssignmentsMobileFilter, {})
        })]
      }), /*#__PURE__*/_jsx(Box, {
        inlineSize: "100%",
        children: isMobile ? /*#__PURE__*/_jsx(View, {
          marginBlockEnd: "500",
          marginBlockStart: "300",
          children: /*#__PURE__*/_jsx(RouterSearchInput, {
            filterType: searchFilter,
            use: "on-dark"
          })
        }) : /*#__PURE__*/_jsx(Flex, {
          gap: "200",
          justifyContent: "end",
          children: /*#__PURE__*/_jsx(FilterBar, {
            endSlot: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(RouterSearchInput, {
                filterType: searchFilter,
                use: "on-dark"
              }), !isMobile && actions]
            }),
            marginBlock: "0"
          })
        })
      })]
    }), children]
  });
};
export default PlaylistAssignmentsTablePage;